import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { updateSetup } from 'store/Recruitment/actions'
import {
  SYSTEM_SETUP_CANDIDATE_CATEGORY,
  SYSTEM_SETUP_JOB_CATEGORY,
  SYSTEM_SETUP_JOB_STAGE,
  SYSTEM_SETUP_SALARY_TYPE,
  SYSTEM_SETUP_SCREEN_INDICATOR,
  SYSTEM_SETUP_SCREENING_TYPE,
} from 'store/Recruitment/reducer'
import CommonSystemSetupInput from './CommonSystemSetupInput'
import CreateScreeningIndicator from './CreateScreeningIndicator'
import { v4 as uuidv4 } from 'uuid'
import { useEffect, useState } from 'react'
import CreateJobCheckbox from '../CreateJob/CreateJobCheckbox'
import { setCurrentSetupSystemData } from 'store/Recruitment/actions'
import { setCurrentSetupSystemRawData } from 'store/Recruitment/actions'

function CreateModal({ showModal, setShowModal }) {
  const dispatch = useDispatch()

  const [generalId, setGeneralId] = useState()

  const {
    activeSystemSetupSidebarRoute,
    editingSystemSetup,
    currentSystemSetupData,
  } = useSelector((store) => store.recruitment)

  const modalActionTitle = `${!editingSystemSetup ? 'Create' : 'Edit'}`

  useEffect(() => {
    if (!generalId) setGeneralId(uuidv4())
  }, [generalId])

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_JOB_CATEGORY &&
          `${modalActionTitle} Job Category`}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_JOB_STAGE &&
          `${modalActionTitle} Job Stage`}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SALARY_TYPE &&
          `${modalActionTitle} Salary Type`}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_CANDIDATE_CATEGORY &&
          `${modalActionTitle} Candidate Category`}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SCREENING_TYPE &&
          `${modalActionTitle} Screening Type`}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SCREEN_INDICATOR &&
          `${modalActionTitle} Screen Indicator`}
      </ModalHeader>
      <ModalBody className='scrollbar'>
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_JOB_CATEGORY && (
          <CommonSystemSetupInput id='createCategory' fieldName='category' />
        )}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_JOB_STAGE && (
          <>
            <CommonSystemSetupInput
              id='createJobStage'
              placeholder='Enter Title'
              label='Title'
            />
            <div className='mt-5'>
              <CreateJobCheckbox
                label='Interview Stage'
                name='terms_and_conditions'
                checked={
                  currentSystemSetupData?.interview_stage &&
                  currentSystemSetupData?.interview_stage !== 'false'
                }
                onChange={(value) =>
                  dispatch(
                    setCurrentSetupSystemRawData({
                      ...currentSystemSetupData,
                      interview_stage: value,
                      hired_stage: false,
                    })
                  )
                }
              />
              <CreateJobCheckbox
                label='Hired Stage'
                name='terms_and_conditions'
                checked={
                  currentSystemSetupData?.hired_stage &&
                  currentSystemSetupData?.hired_stage !== 'false'
                }
                onChange={(value) =>
                  dispatch(
                    setCurrentSetupSystemRawData({
                      ...currentSystemSetupData,
                      hired_stage: value,
                      interview_stage: false,
                    })
                  )
                }
              />
            </div>
          </>
        )}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SALARY_TYPE && (
          <CommonSystemSetupInput id='createSalaryType' />
        )}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_CANDIDATE_CATEGORY && (
          <CommonSystemSetupInput id='createCandidateCategory' />
        )}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SCREENING_TYPE && (
          <CommonSystemSetupInput id='createScreeningType' />
        )}
        {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SCREEN_INDICATOR && (
          <CreateScreeningIndicator generalId={generalId} />
        )}
      </ModalBody>
      <ModalFooter>
        <CancelModalButton
          customFn={() => setShowModal(false)}
        ></CancelModalButton>
        <SubmitModalButton
          customFn={() => {
            dispatch(
              updateSetup(
                () => setShowModal(false),
                editingSystemSetup
                  ? { ...currentSystemSetupData, action: 'update' }
                  : null
              )
            )
          }}
          text={editingSystemSetup ? 'Update' : 'Create'}
        ></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default CreateModal
